import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-4 gap-6" }
const _hoisted_2 = { class: "flex justify-center" }

import PanelTitle from '../PanelTitle/PanelTitle.vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderError',
  props: {
    membershipCardModal: {}
  },
  emits: ['closeChildModal'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const onClose = () => {
  emit('closeChildModal');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex justify-center" }, [
      _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none"
      }, [
        _createElementVNode("path", {
          d: "M40 0C17.9402 0 0 17.7364 0 39.5455V40.4636C0 62.2636 17.9402 80.0091 40 80.0091C62.0598 80.0091 80 62.2727 80 40.4636V39.5455C79.9908 17.7364 62.0506 0 40 0ZM75.3931 40.4545C75.3931 59.7546 59.5126 75.4546 39.9908 75.4546C20.469 75.4546 4.5977 59.7546 4.5977 40.4545V39.5364C4.5977 20.2455 20.4782 4.54545 40 4.54545C59.5218 4.54545 75.4023 20.2455 75.4023 39.5455V40.4636L75.3931 40.4545Z",
          fill: "#D82900"
        }),
        _createElementVNode("path", {
          d: "M55.2736 24.5727C54.1977 23.5091 52.4506 23.5091 51.3747 24.5727L39.669 36.1455L28.6161 25.2182C27.5402 24.1545 25.7931 24.1545 24.7172 25.2182C23.6414 26.2818 23.6414 28.0091 24.7172 29.0727L35.7701 40L24.7172 50.9273C23.6414 51.9909 23.6414 53.7182 24.7172 54.7818C25.7931 55.8455 27.5402 55.8455 28.6161 54.7818L39.669 43.8545L51.3747 55.4273C52.4506 56.4909 54.1977 56.4909 55.2736 55.4273C56.3494 54.3636 56.3494 52.6364 55.2736 51.5727L43.5678 40L55.2736 28.4273C56.3494 27.3636 56.3494 25.6364 55.2736 24.5727Z",
          fill: "#D82900"
        })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PanelTitle, _normalizeProps(_guardReactiveProps(_ctx.membershipCardModal.fields.errorTitle)), null, 16)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(RichText), {
          field: _ctx.membershipCardModal.fields.errorText
        }, null, 8, ["field"])
      ]),
      _createElementVNode("div", { class: "flex flex-col" }, [
        _createElementVNode("button", {
          class: "btn btn-secondary btn-md",
          onClick: onClose
        }, "Close")
      ])
    ])
  ], 64))
}
}

})